import * as UnitTimes from "./unit-times";
export function Squared(name, u) {
    return UnitTimes.lengthByLength(name, u, u);
    // TODO was return u.Times <q.Area> (u);
}
//# sourceMappingURL=unit-squared.js.map